export interface CountMessageVariants {
    empty: string;
    singular: string;
    plural: string;
}

export type CountMessageParams = Record<string, string | number>;

export function buildCountMessage(
    count: number,
    variants: CountMessageVariants,
    params: CountMessageParams = {},
): string {
    let template: string;

    switch (count) {
        case 0:
            template = variants.empty;
            break;
        case 1:
            template = variants.singular;
            break;
        default:
            template = variants.plural;
            break;
    }

    return interpolate(template, { count, ...params });
}

function interpolate(template: string, params: CountMessageParams): string {
    return template.replace(/\{(\w+)\}/g, (match, key: string) =>
        key in params ? String(params[key]) : match,
    );
}
